import RecipientsList from './RecipientsList.component';

export default RecipientsList;
